/**
 * Handle arrow key navigation for tab lists.
 * Returns the new tab ID on arrow key press, or null if no change.
 */
export function handleTabKeydown<T extends string>(
	e: KeyboardEvent,
	ids: readonly T[],
	activeTab: T
): T | null {
	const idx = ids.indexOf(activeTab);
	if (e.key === 'ArrowRight') return ids[(idx + 1) % ids.length];
	if (e.key === 'ArrowLeft') return ids[(idx - 1 + ids.length) % ids.length];
	return null;
}
